export default "__VITE_ASSET__n6Io9I9t__"